// extracted by mini-css-extract-plugin
export default {"header":"Navbar_header__hzCG7","title":"Navbar_title__375uB","homeLink":"Navbar_homeLink__041IC"};